/**
 * Platform API factory function
 */

import { PlatformApi as PlatformApiClient } from '@solink/vd-data-layer/api-clients/platform/platform';
import { AuthenticatedRequestor } from '@solink/vd-data-layer/api-clients/shared/AuthenticatedRequestor';

import settings from '@solinkcorp/settings';
import * as constants from 'vd-constants';
import AuthService from '../models/AuthService';

export type {
  EventCamera,
  EventQueryParameters,
  IEvent,
  Share,
  SubStatsAgg,
} from '@solink/vd-data-layer/api-clients/platform/platform';

export default function PlatformApi(token?: string) {
  const authToken = token ?? AuthService.authToken;
  return new PlatformApiClient(
    new AuthenticatedRequestor(settings.host, constants.REQUEST_TIMEOUT, authToken),
  );
}
